import BSelect from './packages/BSelect'

BSelect.install = function(Vue) {
    Vue.component(BSelect.name, BSelect)
}

export default BSelect
